import { Volume2, VolumeX } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { announceNewOrder, setOrderSoundOn, useOrderSoundOn } from "@/lib/order-sound";

/**
 * Turns the new-order announcement on or off for this browser. Turning it on plays it once, which
 * also lets the browser play it later (browsers only allow sound after a click on the page).
 */
export function OrderSoundToggle() {
  const on = useOrderSoundOn();
  const toggle = () => {
    setOrderSoundOn(!on);
    if (!on) announceNewOrder();
  };
  const label = on ? "New-order sound is on — mute it" : "New-order sound is off — turn it on";
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant="ghost"
            size="icon"
            aria-label={label}
            aria-pressed={on}
            onClick={toggle}
          />
        }
      >
        {on ? <Volume2 /> : <VolumeX className="text-muted-foreground" />}
      </TooltipTrigger>
      <TooltipContent side="bottom">
        {on ? "New-order sound on" : "New-order sound off"}
      </TooltipContent>
    </Tooltip>
  );
}
